<script setup lang="ts">
import { navigationItems, type NavigationItem } from './navigation-links';
import YesPlus from '~/assets/img/yesplus.svg';

import './aside.scss';
import './burger.scss';

const onSelected = async (nav: NavigationItem) => {
    if (nav?.event) {
        await nav.event();
    } else {
        await navigateTo(nav.link);
    }
    closeMenu();
};

const isActive = ref(false);
const closeMenu = () => {
    // Right key down
    if (document) {
        const event = new Event('keydown');
        Object.defineProperty(event, 'keyCode', {
            get: () => 39
        });
        document.dispatchEvent(event);
    }
    isActive.value = false;
};

const route = useRoute();
const isCurrent = (nav: NavigationItem) => {
    return route.path === nav.link || (nav.childCheck && route.path.startsWith(nav.link));
};

const isFocusedAside = ref(false);
// Проверяем смену фокуса только когда был активный блок меню
const { $lrud } = useNuxtApp();
// Отслеживаем фокус на меню
const asideLrudNode = useState('asideLrudNode', () => ref<any>());
$lrud.base.emitter.on('focus', (event) => {
    const asideLrudNodeId = asideLrudNode.value?.el?.id;
    if (asideLrudNodeId && $lrud.base.isSameOrParentForChild(asideLrudNodeId, event)) {
        isFocusedAside.value = true;
    } else {
        isFocusedAside.value = false;
    }
});
</script>

<template>
    <aside ref="aside" class="aside" :class="{ hover: isFocusedAside }">
        <LrudNode ref="asideLrudNode" orientation="vertical" class="aside__wrapper">
            <div class="aside-before"></div>
            <div class="aside-menu" :class="{ 'is-open': isActive }">
                <LrudNode
                    v-for="(nav, index) in navigationItems"
                    :key="index"
                    isFocusable
                    class="aside-menu__item"
                    :class="{
                        'aside-menu__current': isCurrent(nav),
                        'aside-menu__yes': nav.title === YesPlus
                    }"
                    @selected="onSelected(nav)"
                >
                    <div class="aside-menu__link" @click="closeMenu()">
                        <span class="aside-menu__icon">
                            <Component :is="nav.icon" />
                        </span>
                        <span class="aside-menu__text fs-28">
                            <span v-if="typeof nav.title == 'string'">{{ nav.title }}</span>
                            <Component :is="nav.title" v-else />
                        </span>
                    </div>
                </LrudNode>
            </div>
            <div class="aside-after">
                <div class="aside-version">#VER#</div>
            </div>
        </LrudNode>
    </aside>
</template>
